export default function Partnership() {
  const categories = [
    {
      title: 'INSTITUTIONAL INVESTORS',
      description: 'Pension funds, endowments, and institutional capital partners seeking infrastructure and industrial investment opportunities.'
    },
    {
      title: 'DEVELOPMENT PARTNERS',
      description: 'Experienced developers and operators with proven track records in large-scale infrastructure and industrial projects.'
    },
    {
      title: 'INDUSTRY OPERATORS',
      description: 'Operational experts in logistics, manufacturing, energy, and industrial sectors driving project execution.'
    }
  ];

  return (
    <section id="partnership" className="bg-black">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left panel - Gold */}
        <div className="bg-yellow-600 flex items-center justify-center py-16 sm:py-24 lg:py-32 px-6 sm:px-12">
          <div className="max-w-xl text-center">
            <h2 className="text-black text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 leading-tight">
              STRATEGIC<br />PARTNERSHIPS
            </h2>
            <div className="w-24 h-0.5 bg-black mx-auto mb-6 sm:mb-8"></div>
            <p className="text-black/80 text-base sm:text-lg font-light leading-relaxed mb-8 sm:mb-12 max-w-md mx-auto">
              Ark Capital™ partners with developers, institutional investors, private investors, and industry operators to structure and execute complex investment projects. Our collaborative approach ensures each project benefits from experienced leadership, financial strength, and operational expertise.
            </p>
            <a
              href="#contact"
              className="inline-block bg-black text-yellow-600 px-10 sm:px-14 py-4 font-semibold tracking-wide hover:bg-zinc-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              BECOME A PARTNER
            </a>
          </div>
        </div>

        {/* Right panel - Black with categories */}
        <div className="bg-black relative flex items-center justify-center py-16 sm:py-24 lg:py-32 px-6 sm:px-12">
          {/* Diagonal pattern background */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(214,175,55,0.5) 35px, rgba(214,175,55,0.5) 36px)'
            }}></div>
          </div>

          <div className="relative z-10 max-w-xl w-full space-y-8 sm:space-y-12">
            {categories.map((category, index) => (
              <div key={index} className="border-l-[3px] border-yellow-600 pl-6 sm:pl-8">
                <h3 className="text-white text-lg sm:text-xl font-bold mb-2 sm:mb-3">
                  {category.title}
                </h3>
                <p className="text-white/70 text-sm font-light leading-relaxed">
                  {category.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
